import { BuildingOverdueInvoicesDto } from '@client/api';
import i18n from 'i18next';

export const transformToExcelFormat = (data: BuildingOverdueInvoicesDto[], selectedRows: Set<string>) => {
  const rows: Record<string, any>[] = [];
  if (data.length === 0) return [{ [i18n.t('noData', { ns: 'reporting' })]: null }];
  data.forEach((item) => {
    if (selectedRows.has(item.buildingId) || selectedRows.size === 0) {
      rows.push({
        [i18n.t('overdueInvoices.building', { ns: 'reporting' })]: item.buildingName,
        [i18n.t('overdueInvoices.tenants', { ns: 'reporting' })]: item.tenantCount,
        [i18n.t('overdueInvoices.totalOverdue', { ns: 'reporting' })]: item.currentPeriodOutstanding.value,
        [i18n.t('overdueInvoices.invoiceNumber', { ns: 'reporting' })]: item.currentPeriodInvoiceCount,
        [i18n.t('overdueInvoices.invoicesDes', { ns: 'reporting' })]: null,
        [i18n.t('overdueInvoices.dueDate', { ns: 'reporting' })]: null,
        [i18n.t('overdueInvoices.daysOverdue', { ns: 'reporting' })]: null,
      });
      item.tenantOverdueInvoices.forEach((tenant) => {
        rows.push({
          [i18n.t('overdueInvoices.building', { ns: 'reporting' })]: null,
          [i18n.t('overdueInvoices.tenants', { ns: 'reporting' })]: tenant.tenantName,
          [i18n.t('overdueInvoices.totalOverdue', { ns: 'reporting' })]: tenant.currentPeriodOutstanding.value,
          [i18n.t('overdueInvoices.invoiceNumber', { ns: 'reporting' })]: tenant.currentPeriodInvoiceCount,
          [i18n.t('overdueInvoices.invoicesDes', { ns: 'reporting' })]: null,
          [i18n.t('overdueInvoices.dueDate', { ns: 'reporting' })]: null,
          [i18n.t('overdueInvoices.daysOverdue', { ns: 'reporting' })]: null,
        });
        tenant.invoices.forEach((invoice) => {
          rows.push({
            [i18n.t('overdueInvoices.building', { ns: 'reporting' })]: null,
            [i18n.t('overdueInvoices.tenants', { ns: 'reporting' })]: null,
            [i18n.t('overdueInvoices.totalOverdue', { ns: 'reporting' })]: invoice.amountOutstanding.value,
            [i18n.t('overdueInvoices.invoiceNumber', { ns: 'reporting' })]: invoice.invoiceNumber,
            [i18n.t('overdueInvoices.invoicesDes', { ns: 'reporting' })]: invoice.invoiceText,
            [i18n.t('overdueInvoices.dueDate', { ns: 'reporting' })]: invoice.dueDate,
            [i18n.t('overdueInvoices.daysOverdue', { ns: 'reporting' })]: invoice.daysOverdue,
          });
        });
      });
    }
  });
  return rows;
};
